import { render, staticRenderFns } from "./ProfileFilter.vue?vue&type=template&id=0b0f544e&scoped=true&"
import script from "./ProfileFilter.vue?vue&type=script&lang=js&"
export * from "./ProfileFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFilter.vue?vue&type=style&index=0&id=0b0f544e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f544e",
  null
  
)

export default component.exports